import { Grid } from "@mui/material";
import React, { useEffect,useRef, useState } from "react";
import { GreenColorButton, PrimeGrayBorderColorButton } from "../../../Components/MaterialButtonStyle/StyleButton";
import PSCLogo from "../../../Assets/Logo/PSCLogo.jpg";
import CustomModal from "../../../Components/Modal/CustomModal";
import { FormatDate, FormatDay } from "../../../Components/Helpers/DateTimeConverter";
import { GetPublicURL } from "../../../Helper/api";
import generatePDF, {  Resolution } from "react-to-pdf";
const CallLetterModal = ({ callLetter, setCallLetter, heading, postName, year,CandidateDetail ,applicationDetail,CharmanSignatures,CharmanName,callLetterName}) => {
  const TextFormat = "<h3><strong>Instructions for the Candidate:</strong></h3><p><br/></p><p><strong>1.Arrival:</strong> </p><ul><li>Candidates are required to arrive at least [X] minutes before the test start time. Latecomers will not be allowed to participate in the test.</li></ul><p><strong>2.Documents Required:</strong></p><ul><li>A printed copy of this call letter (mandatory).</li>li>Relevant documents based on the test type (e.g., medical reports for the medical examination, sports gear for the physical test, etc.).</li></ul><p><strong>3.Test Guidelines:</strong></p><ul><li>Ensure you follow the instructions provided by the test officials during the session.</li><li>For the physical test, wear appropriate sports attire and shoes.</li><li>For the Computer-Based Test, you will be provided with a system to take the test. Bring a pen/pencil for rough work if needed.</li><li>For the medical examination, provide any prior medical reports as requested.</li></ul><p><strong>4.Health &amp; Safety:</strong></p><p>	Candidates are advised to follow the COVID-19 health protocols (if applicable). Wear a mask and maintain social distancing.</p><p><strong>5.Disqualification:</strong></p><p>	Failure to bring the required documents or non-compliance with the instructions will lead to disqualification from the recruitment process.</p>"
  // const TextFormat = "<h3><strong>Instructions for the Candidate:</strong></h3><p><br/></p><p><strong>1.Arrival:</strong> </p><ul><li>Candidates are required to arrive at least [X] minutes before the test start time. Latecomers will not be allowed to participate in the test.</li></ul><p><strong>2.Documents Required:</strong></p><ul><li>A printed copy of this call letter (mandatory).</li><li>A valid photo ID (NIN card, passport, or driver’s license).</li><li>Relevant documents based on the test type (e.g., medical reports for the medical examination, sports gear for the physical test, etc.).</li></ul><p><strong>3.Test Guidelines:</strong></p><ul><li>Ensure you follow the instructions provided by the test officials during the session.</li><li>For the physical test, wear appropriate sports attire and shoes.</li><li>For the Computer-Based Test, you will be provided with a system to take the test. Bring a pen/pencil for rough work if needed.</li><li>For the medical examination, provide any prior medical reports as requested.</li></ul><p><strong>4.Health &amp; Safety:</strong></p><p>	Candidates are advised to follow the COVID-19 health protocols (if applicable). Wear a mask and maintain social distancing.</p><p><strong>5.Disqualification:</strong></p><p>	Failure to bring the required documents or non-compliance with the instructions will lead to disqualification from the recruitment process.</p>"
  const targetRef = useRef();
  const [profileImage,setprofileImage]=useState()
  const [applicantSignature,setapplicantSignature]=useState()
  const [CharmanSignature,setCharmanSignature]=useState()
  useEffect(()=>{
    if(applicationDetail?.applicant_image){
      AdminConvertbase64(applicationDetail.applicant_image)
    }
    if(applicationDetail?.applicant_signature){
      AdminConvertbase641(applicationDetail.applicant_signature)
    }
    if(CharmanSignatures){
      AdminConvertbase642(CharmanSignatures)
    }

  },[CandidateDetail])
  const Options = {
    method: "open",
    resolution: Resolution.HIGH,
    page: {
      margin: 5,
      format: "letter",
      orientation: "potrait",
    },
    overrides: {
      pdf: {
        compress: true,
      },
    },
  };
  const AdminConvertbase64 = async (image) => {
    try {
      let images =await GetPublicURL(image);
      fetch(images, {
        method: "GET",
      })
        .then((response) => response.blob())
        .then((blob) => {
          const source = URL.createObjectURL(blob);
          setprofileImage(source);
        })
        .catch((error) => console.error("Error fetching image:", error));
    } catch (Error) {
      console.log("Error", Error);
    }
  };
  const AdminConvertbase641 = async (image) => {
    try {
      let images =await GetPublicURL(image);
      fetch(images, {
        method: "GET",
      })
        .then((response) => response.blob())
        .then((blob) => {
          const source = URL.createObjectURL(blob);
          setapplicantSignature(source);
        })
        .catch((error) => console.error("Error fetching image:", error));
    } catch (Error) {
      console.log("Error", Error);
    }
  };
  const AdminConvertbase642 = async (image) => {
    try {
      let images =await GetPublicURL(image);
      fetch(images, {
        method: "GET",
      })
        .then((response) => response.blob())
        .then((blob) => {
          const source = URL.createObjectURL(blob);
          setCharmanSignature(source);
        })
        .catch((error) => console.error("Error fetching image:", error));
    } catch (Error) {
      console.log("Error", Error);
    }
  };
  return (
    <CustomModal
      open={callLetter}
      setOpen={setCallLetter}
      divider={false}
      header={true}
      width={"60%"}
      modalTitle={
        <h5 className="poppinsSemiBold Text-Prime-Black text-left">
          {heading ? heading : ""}
        </h5>
      }
      contentScroll={true}
      modalContent={
        <Grid item ref={targetRef} lg={12} md={12} sm={12} xs={12} className="px-3">
          <Grid item lg={12} sm={12} md={12} xs={12} container className="" border={"1px solid #666666"}>
            <Grid item lg={12} sm={12} md={12} xs={12} container className="p-3" borderBottom={"1px solid #666666"}>
              <Grid item lg={2} sm={4} md={4} xs={4} container justifyContent={"center"} >
                <img src={PSCLogo} alt="PSCLogo" height={80} width={80} className="img_fluid" />
              </Grid>
              <Grid item lg={10} sm={8} md={8} xs={8} container alignItems={"center"} flexDirection={"column"}>
                <h4 className="poppinsSemiBold Text-Prime-Black my-1">
                  Police Service Commission
                </h4>
                <p className="poppinsRegular Text-Prime-Gray">
                  Corporate Headquarters, Plot 64, Cadastral Zone B16, Sector Centre B, Jabi, Abuja
                </p>
                <p className="poppinsRegular Text-Prime-Gray">
                  Website: https://psc.gov.ng/
                </p>
              </Grid>
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12} className="p-2" container justifyContent={"center"} borderBottom={"1px solid #666666"}>
              <p className="poppinsSemiBold text-black text-center"> {heading} for the Posts {postName} for the year {year}</p>
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12} container>
              <table style={{ width: "100%" }}>
                <tr>
                  <td style={{ borderBottom: "1px solid #666666" }}>
                    <p className="poppinsSemiBold text-black text-left px-2 ">
                      Register No:
                    </p>
                    <span className="poppinsRegular text-black text-left fontSize12 px-2 ">{applicationDetail?.application_serial ? applicationDetail.application_serial : "--"}</span>
                  </td>
                  <td style={{ borderLeft: "1px solid #666666", borderBottom: "1px solid #666666" }}>
                    <p className="poppinsSemiBold text-black text-left px-2 ">
                      Schedule Date& Time of Test
                    </p> 
                    {callLetterName =="Physical"? 
                      <span className="poppinsRegular text-black text-left pt-1 px-2  fontSize12">{applicationDetail?.physical_test_date ? (FormatDay(applicationDetail?.physical_test_date) + ", " + FormatDate(applicationDetail?.physical_test_date)): "--"}</span>
                      :callLetterName =="Computer"?
                        <span className="poppinsRegular text-black text-left pt-1 px-2  fontSize12">{applicationDetail?.computer_test_date ? (FormatDay(applicationDetail?.computer_test_date) + ", " + FormatDate(applicationDetail?.computer_test_date)): "--"}</span>
                        :
                        <span className="poppinsRegular text-black text-left pt-1 px-2  fontSize12">{applicationDetail?.medical_test_date ? (FormatDay(applicationDetail?.medical_test_date) + ", " + FormatDate(applicationDetail?.medical_test_date)): "--"}</span>
                    }

                  </td>
                  <th align="center" style={{ borderLeft: "1px solid #666666", borderBottom: "1px solid #666666" }}>
                    <Grid item container justifyContent={"center"} className="py-4" >
                      <img src={profileImage} alt="Profile" height={150} width={150} className="img_fluid" />
                    </Grid>
                  </th>
                </tr>
                <tr >
                  <td style={{ borderBottom: "1px solid #666666" }} >
                    <p className="poppinsSemiBold text-black text-left px-2 ">
                      Name of the Applicant:
                    </p>
                    <span className="poppinsRegular text-black text-left px-2  fontSize12">
                      {CandidateDetail?.Title ? CandidateDetail?.Title : ""} . {" "}{CandidateDetail?.Surname ? CandidateDetail?.Surname : ""} {CandidateDetail.LastName ? CandidateDetail.LastName : "--"}
                    </span>
                  </td>
                  <td rowSpan="2" style={{ borderLeft: "1px solid #666666" }}>
                    <p className="poppinsSemiBold text-black text-left px-2 ">
                      Center Name:
                    </p>
                    {callLetterName =="Physical"? 
                      <span className="poppinsRegular text-black text-left pt-1 px-2 fontSize12">{applicationDetail.physical_locations ?applicationDetail?.physical_locations[0]?.value : "--"}</span>
                      :callLetterName =="Computer"?
                        <span className="poppinsRegular text-black text-left pt-1 px-2 fontSize12">{applicationDetail.computer_locations ?applicationDetail?.computer_locations[0]?.value : "--"}</span>
                        : 
                        <span className="poppinsRegular text-black text-left pt-1 px-2 fontSize12">{applicationDetail.medical_locations ?applicationDetail?.medical_locations[0]?.value : "--"}</span>
                    }
                    
                    <p className="poppinsSemiBold text-black text-left px-2 pt-2">
                      Venue Address:
                    </p>
                    {callLetterName =="Physical"? 
                      <span className="poppinsRegular text-black text-left pt-1 px-2 fontSize12">{applicationDetail.physical_locations ?applicationDetail?.physical_locations[0]?.value : "--"}</span>
                      :callLetterName =="Computer"?
                        <span className="poppinsRegular text-black text-left pt-1 px-2 fontSize12">{applicationDetail.computer_locations ?applicationDetail?.computer_locations[0]?.value : "--"}</span>
                        : 
                        <span className="poppinsRegular text-black text-left pt-1 px-2 fontSize12">{applicationDetail.medical_locations ?applicationDetail?.medical_locations[0]?.value : "--"}</span>
                    }
                  </td>
                  <td align="center" style={{ borderLeft: "1px solid #666666", borderBottom: "1px solid #666666" }}>
                    <Grid item className="py-4" >
                      <Grid item container justifyContent={"center"} >
                        <img src={applicantSignature} alt="Signature" height={80} width={160} className="img_fluid" />
                      </Grid>
                      <p className="poppinsSemiBold text-black text-center">
                        Applicant Signature
                      </p>
                    </Grid>
                  </td>
                </tr>
                <tr>
                  <td >
                    <p className="poppinsSemiBold text-black text-left px-2 ">
                      Next of Kin Name:
                    </p>
                    <span className="poppinsRegular text-black text-left  px-2 fontSize12">{applicationDetail?.kin_details? applicationDetail?.kin_details[0]?.value+" "+applicationDetail?.kin_details[1]?.value : "--"}</span>
                  </td>
                  <td align="center" style={{ borderLeft: "1px solid #666666" }}>
                    <Grid item className="py-4" >
                      <p className="poppinsSemiBold text-black mx-2">
                        Application Number
                      </p>
                      <span className="poppinsRegular text-black mx-2 fontSize12">{applicationDetail?.application_serial ? applicationDetail.application_serial : "--"}</span>
                    </Grid>
                  </td>
                </tr>
              </table>
            </Grid>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} container>
            <div
              dangerouslySetInnerHTML={{ __html: TextFormat }}
              style={{ padding: "20px", fontFamily: "'Poppins', sans-serif", lineHeight: "1.6" }}
            />
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} container className="p-3" justifyContent={"flex-end"} >
            <Grid item lg={3} sm={3} md={3} xs={3} container flexDirection={"column"} alignItems={"center"}>
              <p className="poppinsRegular Text-Prime-Black pb-2 text-center">
                With Regards,
              </p>
              <img src={CharmanSignature} alt="Signature" height={80} width={160} className="img_fluid" />
              <p className="poppinsSemiBold text-black text-center">
                {CharmanName}
              </p>
            </Grid>
          </Grid>
        </Grid>
      }
      modalFooter={
        <Grid item lg={12} md={12} sm={12} xs={12} container justifyContent={"flex-end"}>
          <PrimeGrayBorderColorButton
            type="submit"
            className="px-3 py-2"
            onClick={() => setCallLetter(false)}
          >
            CANCEL
          </PrimeGrayBorderColorButton>
          <GreenColorButton
            type="submit"
            onClick={() => generatePDF(targetRef, Options)}
            className="px-3 py-2 ml-3"
          >
            Print
          </GreenColorButton>
        </Grid>
      }
    />
  );
};

export default CallLetterModal;
